import type { LinksFunction } from '@remix-run/node';
import { Outlet } from '@remix-run/react';
import { AuthLayout } from '~/components/auth-layout';

export const links: LinksFunction = () => {
  return [
    { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
    { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossOrigin: 'anonymous' },
    {
      rel: 'stylesheet',
      href: 'https://fonts.googleapis.com/css2?family=Be+Vietnam+Pro:wght@200;400;700&display=swap'
    }
  ];
};

export default function Auth() {
  return (
    <AuthLayout>
      <Outlet />
    </AuthLayout>
  );
}
